<template>
  <div class="mx-auto w-full max-w-sm lg:w-96">
    <div>
      <img
        class="h-6 w-auto"
        src="/img/traveloffice-logo.svg"
        alt="Workflow"
      >
      <h2 class="mt-4 text-3xl leading-9 font-extrabold text-gray-900">
        Request a password reset
      </h2>

      <div class="mb-4 text-sm text-gray-600">
        Forgot your password? No problem. Just let us know your email address and we will email you a password reset link that will allow you to choose a new one.
      </div>
    </div>

    <div
      v-if="status"
      class="mb-4 font-medium text-sm text-green-600"
    >
      {{ status }}
    </div>

    <jet-validation-errors class="mb-4" />

    <form @submit.prevent="submit">
      <div>
        <jet-label
          for="email"
          value="Email"
        />
        <jet-input
          id="email"
          v-model="form.email"
          type="email"
          class="mt-1 block w-full"
          required
          autofocus
        />
      </div>

      <div class="flex justify-between">
        <div class="flex items-center justify-start mt-4">
          <Link
            :href="route('login')"
            class="underline text-sm text-gray-600 hover:text-gray-900"
          >
            Go back
          </Link>
        </div>

        <div class="flex items-center justify-end mt-4">
          <jet-button
            :class="{ 'opacity-25': form.processing }"
            :disabled="form.processing"
          >
            Password Reset Link
          </jet-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import JetButton from '../../Jetstream/Button.vue';
import JetInput from '../../Jetstream/Input.vue';
import JetLabel from '../../Jetstream/Label.vue';
import JetValidationErrors from '../../Jetstream/ValidationErrors.vue';
import AuthLayout from '../../Layouts/AuthLayout.vue';
import {Link} from '@inertiajs/vue3'

export default {
  components: {
    JetButton,
    JetInput,
    JetLabel,
    JetValidationErrors,
      Link,
  },
  layout: AuthLayout,
  props: {
    status: String,
  },

  data() {
    return {
      form: this.$inertia.form({
        email: '',
      }),
    };
  },

  methods: {
    submit() {
      this.form.post(this.route('password.email'));
    },
  },
};
</script>
